import { Navigate, Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "./components/layouts/Layout";
import Home from "./pages/home/Home";
import GroupOverview from "./pages/about/group-overview/GroupOverview";
import { QueryClient, QueryClientProvider } from "react-query";

import Subsidiaries from "./pages/about/subsidiaries/Subsidiaries";
import Markets from "./pages/about/markets/Markets";
import Awards from "./pages/about/awards/Awards";
import History from "./pages/about/history/History";
import SoftwareDevelopment from "./pages/solutions/software-development/SoftwareDevelopment";
import CapabilityBuildingPrograms from "./pages/solutions/capability-building-programs/CapabilityBuildingPrograms";
import InvestingStartups from "./pages/solutions/investing-startups/InvestingStartups";
import VocationalEducation from "./pages/solutions/vocational-education/VocationalEducation";
import Publishing from "./pages/solutions/publishing/Publishing";
import DigitalLearning from "./pages/solutions/digital-learning/DigitalLearning";
import SocialImpact from "./pages/about/social-impact/SocialImpact";
import ProjectsPage from "./pages/projects/Projects";
import Projects from "./pages/about/social-impact/projects/Projects";
import PrintingAcademy from "./pages/educational-institutions/printing-academy/PrintingAcademy";
import AppliedTechnologySchool from "./pages/educational-institutions/applied-technology-school/AppliedTechnologySchool";
import InternationalAcademy from "./pages/educational-institutions/international-academy/InternationalAcademy";
import ExamCenter from "./pages/educational-certificates/exam-center/ExamCenter";
import ContactUs from "./pages/contact-us/ContactUs";
import ProjectDetails from "./pages/projects/project-details/ProjectDetails";
import News from "./pages/news/News";
import NewsDetails from "./pages/news/news-details/newsDetails";
import Blogs from "./pages/blogs/Blogs";
import BlogsDetails from "./pages/blogs/blogs-details/blogsDetails";
import Teaching from "./pages/solutions/teaching/Teaching";
import Corporates from "./pages/solutions/corporates/Corporates";
import HigherEducation from "./pages/solutions/higherEducation/HigherEducation";
import K12 from "./pages/solutions/k-12/K12";
import Search from "./pages/search/Search";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDataWebsiteSearch } from "./app/search/searchSlice";
import NotFoundPage from "./pages/not-found/NotFound";
import LanguageRouter from "./components/LanguageRouter";
// import axios from "axios";

function SEOUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    // استدعاء وظيفة تحديث بيانات SEO في كل مرة يتغير فيها المسار
    if (window.fetchSEOData) {
      window.fetchSEOData();
    }
  }, [location.pathname]);
  
  return null; // هذا مكون وظيفي لا يعرض أي عناصر
}
function App() {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  const dispatch = useDispatch();
  const [defaultActiveKey, setDefaultActiveKey] = useState("Services");
  const location = useLocation();

  // إضافة useEffect للتمرير التلقائي
  useEffect(() => {
    // تأخير صغير للتأكد من تحميل المحتوى
    const timer = setTimeout(() => {
      const hash = location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // إذا لم يكن هناك hash، نعود إلى أعلى الصفحة
        window.scrollTo(0, 0);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  const handleSidebarLinkClick = (key) => {
    setDefaultActiveKey(key);
  };

  return (
    <>
          <SEOUpdater />

      <QueryClientProvider client={client}>
        <Layout handleSidebarLinkClick={handleSidebarLinkClick} defaultActiveKey={defaultActiveKey}>
        <LanguageRouter>
            <Routes>
            <Route exact path="/" element={<Navigate to="/ar/home" replace />} />

              {/* إعادة التوجيه عند فتح "/en" أو "/ar" إلى "/en/home" أو "/ar/home" */}
              <Route path="/en" element={<Navigate to="/en/home" replace />} />
              <Route path="/:lang">
                <Route path="home" element={<Home />} />
              <Route path="about">
                <Route path="group-overview" element={<GroupOverview />} />
                <Route path="subsidiaries" element={<Subsidiaries />} />
                <Route path="markets" element={<Markets />} />
                <Route path="awards" element={<Awards />} />
                <Route path="history" element={<History />} />
                <Route path="social-impact" element={<SocialImpact />} />
                <Route path="social-impact/projects/:id" element={<Projects />} />
              </Route>

              <Route path="solutions">
                <Route path="k-12" element={<K12 defaultActiveKey={defaultActiveKey} />} />
                <Route path="higher-education" element={<HigherEducation defaultActiveKey={defaultActiveKey} />} />
                <Route path="publishing" element={<Publishing defaultActiveKey={defaultActiveKey} />} />
                <Route path="vocational-education" element={<VocationalEducation />} />
                <Route path="corporates" element={<Corporates />} />
                <Route path="Teaching" element={<Teaching />} />
                <Route path="investing-startups" element={<InvestingStartups />} />
                <Route path="publishing" element={<Publishing />} />
              </Route>


                <Route path="projects" element={<ProjectsPage />} />
                <Route path="projects/project-details/:id" element={<ProjectDetails />} />

                {/* Educational Routes */}
              <Route path="educational-institutions">
                <Route path="printing-academy" element={<PrintingAcademy />} />
                <Route path="applied-technology-school" element={<AppliedTechnologySchool />} />
                <Route path="international-academy" element={<InternationalAcademy />} />
              </Route>
              
              <Route path="educational-certificates">
                <Route path="exam-center" element={<ExamCenter />} />
              </Route>
                {/* <Route path="educational-certificates/exam-center" element={<ExamCenter />} /> */}


                <Route path="contact-us" element={<ContactUs />} />
                <Route path="news" element={<News />} />
                <Route path="news/news-details/:id" element={<NewsDetails />} />
                <Route path="blogs" element={<Blogs />} />
                <Route path="blogs/blogs-details/:id" element={<BlogsDetails />} />

                <Route path="search/:searchKey" element={<Search />} />
                <Route path="not-found" element={<NotFoundPage />} />

              </Route>
            </Routes>
        </LanguageRouter>

          {/* <Routes>
            <Route exact path="/" element={<Navigate to="/home" />} />

            <Route path="/home" element={<Home />} />
            <Route path="about/group-overview" element={<GroupOverview />} />
            <Route path="about/subsidiaries" element={<Subsidiaries />} />
            <Route path="about/markets" element={<Markets />} />
            <Route path="about/awards" element={<Awards />} />
            <Route path="about/history" element={<History />} />
            <Route path="about/social-impact" element={<SocialImpact />} />
            <Route path="about/social-impact/projects/:id" element={<Projects />} />

            <Route path="solutions/k-12" element={<K12 defaultActiveKey={defaultActiveKey}  />} />
            <Route path="solutions/software" element={<SoftwareDevelopment />} />
            <Route path="solutions/capability-building-programs" element={<CapabilityBuildingPrograms />} />
            <Route path="solutions/investing-startups" element={<InvestingStartups />} />
            <Route path="solutions/vocational-education" element={<VocationalEducation />} />
            <Route path="solutions/publishing" element={<Publishing defaultActiveKey={defaultActiveKey} />} />
            <Route path="solutions/digital-learning" element={<DigitalLearning />} />
            <Route path="solutions/teaching" element={<Teaching />} />
            <Route path="solutions/corporates" element={<Corporates />} />
            <Route path="solutions/higher-education" element={<HigherEducation defaultActiveKey={defaultActiveKey} />} />

            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/project-details/:id" element={<ProjectDetails />} />

            <Route path="educational-institutions/printing-academy" element={<PrintingAcademy />} />
            <Route path="educational-institutions/applied-technology-school" element={<AppliedTechnologySchool />} />
            <Route path="educational-institutions/international-academy" element={<InternationalAcademy />} />
            <Route path="educational-certificates/exam-center" element={<ExamCenter />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="news" element={<News />} />
            <Route path="news/news-details/:id" element={<NewsDetails />} />

            <Route path="search/:searchKey" element={<Search />} />
            <Route path="not-found" element={<NotFoundPage />} />

          </Routes> */}
        </Layout>
      </QueryClientProvider>
    </>
  );
}

const LanguageWrapper = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!['ar', 'en'].includes(lang)) {
      navigate('/ar', { replace: true });
    }
  }, [lang, navigate]);
  
  return <Outlet />;
};

export default App;
